module.exports = __webpack_public_path__ + "img/project-2.285b4964.jpg";